<template lang="pug">
  Layout
    v-overlay(:value="isLoading")
      v-progress-circular(:value="20" indeterminate)
    v-container.media.py-0(fluid)
      v-row(style="min-height:200px")
        v-col(md="3", sm="4", xs="12")
          FormWrapper.fill-height(
            type="media",
            :form-class="['pa-0']",
          )
            template( v-slot:default="props")
              MediaForm.fill-height(
                :enable-scanner="true",
                :model="props.model",
                :validate="props.validate",
                :valid="props.valid",
                :reset="props.reset",
                @updated="fetchMedia(); flushSelections();",
                :media="selections[0]",
              )
                template(v-slot="{ open }")
                  v-card.media-item.add-box(
                    @click="open(true)",
                  )
                    v-icon(color="primary") fas fa-cloud-upload-alt
                  v-card(
                    ref="uploadBtn",
                    v-show="false",
                    @click="open(false)",
                  )
        v-col(
          v-for="media in medias", :key="media.id",
          md="3", sm="4", xs="12",
        )
          v-card.media_item(:class="{ 'media_video': media.is_video }")
            Projector(
              show-mask,
              :active="exist(media.id)",
              :media="media",
              @preview="previewMedia(media)",
            )
      Previewer(
        v-if="previewer",
        :selections="selections",
        :value.sync="previewer",
      )
      Controller(
        :selections="selections",
        @delete="remove",
        @download="download",
        @edit="$refs.uploadBtn.click()",
        @preview="previewer = true",
        @remove="previewMedia",
        @showLogs="showLogs",
      )

</template>

<script>
import { mapGetters } from 'vuex';
import { imageViewer, progressWrapper } from '@/config/mixins.js';

import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Layout from '@/layouts/User.vue';
import MediaForm from '@/components/forms/Media.vue';
import Projector from '@/components/Media/Projector.vue';

export default {
  mixins: [imageViewer, progressWrapper],

  components: {
    FormWrapper,
    Layout,
    MediaForm,
    Projector,
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
      medias: 'media/items',
    }),
  },

  methods: {
    fetchMedia() {
      this.$store.dispatch('media/fetch', {
        user_id: this.$route.params.id,
        limit: 1000,
        skip: 0,
      });
    },
  },
};
</script>
